<template>
    <div class="text-md-right bottom-part__content" v-if="step > 1">
        <button v-if="step > 1 && step < 4"
                @click="back"
                :disabled="loading"
                class="btn btn-themed-secondary bottom-btn">Назад</button>
        <button v-if="step == 4 && order && !actionsBlock"
                @click="cancelOrder"
                :disabled="loading || isInPaymentProcess"
                class="btn btn-themed-secondary bottom-btn">Отменить</button>
        <button v-if="step > 1 && step < 4 && cart.length > 0 && !actionsBlock"
                :disabled="loading"
                @click="checkout"
                class="btn btn-themed bottom-btn ml-2">Оформить</button>
        <button v-if="step == 4 && order && checkouttime > 0 && !actionsBlock"
                @click="fillOrder"
                :disabled="loading"
                class="btn btn-themed bottom-btn ml-2">
            <span class="d-md-inline d-none">Перейти к оплате</span>
            <span class="d-md-none d-inline">К оплате</span>
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '../../../../event-bus'

export default {
    name: "BottomPart",
    computed: {
        ...mapState(['step','cart','order','timetable','checkouttime','actionsBlock', 'isInPaymentProcess'])
    },
    methods: {
        back() {
            if(this.step == 2) {
                this.$router.push('/')
            }
            if(this.step == 3) {
                if(this.timetable && this.timetable.type == 'pricegroups') {
                    this.$router.push('/')
                } else {
                    this.$store.commit('setStep', 2)
                }

            }
        },
        checkout() {
            this.loading = true
            this.$store.dispatch('generateOrder').then(res => {
                window.loaderIcon(false)
                this.loading = false
                this.$router.push('/order/'+res.id+'/'+res.hash)
            })
        },
        cancelOrder() {
            if(!this.order) return
            this.loading = true
            window.loaderIcon()
            axios.delete(`/api/order/${this.order.id}/${this.order.hash}`).then(res => {
                this.loading = false
                this.$router.push('/')
            })
        },
        fillOrder() {
            // this.loading = true
            EventBus.$emit('fillOrder')
        }
    },
    data() {
        return {
            loading: false,
        }
    }
}
</script>

<style scoped>

</style>
